import axios from 'axios'
import store from '../store'

const API = axios.create({
  baseURL: process.env.VUE_APP_URL_CONFIGURADOR_PUBLICO_API
})

// Intercepta a requisição e adiciona o Authorization
API.interceptors.request.use((config) => {
  const token = store.state.login.token
  if (token) {
    config.headers.Authorization = token
  }
  return config
}, (err) => Promise.reject(err))

export default {
  listaAplicacoes () {
    return API.get('aplicacoes?tipoAplicacao=all')
  },
  carregaVersoesAtivas ({ idConfigClienteApp, options = {} }) {
    return API.get(`/cliente/aplicacao/${idConfigClienteApp}/versao/ativas`)
  },
  listarEsquemaDeCores ({ idConfigClienteApp, idVersao, params, options = {} }) {
    const url = `/cliente/aplicacao/${idConfigClienteApp}/versao/${idVersao}/esquemaDeCores`
    const request = API.get(url, {
      headers: params
    })
    return request
  },
  carregarEsquemaDeCores ({ idConfigClienteApp, idVersao, idEsquemaDeCores, options = {} }) {
    const url = `/cliente/aplicacao/${idConfigClienteApp}/versao/${idVersao}/esquemaDeCores/${idEsquemaDeCores}`
    const request = API.get(url)
    return request
  }
}
